import React, { useRef } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import RequestApi from "../../api/RequestApi";
import axios from "axios";
import config from "./../../api/config";

function InputUploadTesting({chapterId, onLoading, onReload}) {
    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];

        if (!file) return;
        if (file.type !== 'text/plain') {
            alert('Можно загружать только .txt файлы');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('chapterId', chapterId);
        onLoading(true);
        try {
            const response = await axios.post(config.host + '/api/private/testing/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
            });

            console.log('Файл успешно отправлен:', response.data);
        } catch (error) {
            console.error('Ошибка при отправке файла:', error);
        } finally {
            onLoading(false);
            onReload();
            event.target.value = null; // <— сброс после отправки
        }

    };

    return (
        <div onClick={handleButtonClick}
             className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
            <FontAwesomeIcon icon={faPlus}/>
            <span> Загрузить тестирования</span>
            <input
                type="file"
                accept=".txt"
                ref={fileInputRef}
                style={{display: 'none'}}
                onChange={handleFileChange}
            />
        </div>
    )
        ;
}

export default InputUploadTesting;
